module.exports = __webpack_public_path__ + "static/money-with-wings-91fe1d46d34c1a1777c58f4a24ff39fd.png";